import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { t } from 'i18next';
import React, { FC, useEffect, useState } from 'react';
import { SCUIDateRanger } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import { CommentCommand } from '../../services/command';
import { CommentQuery, OperatorQuery } from '../../services/query';
import { enumCommentRoleID } from '../../types/enums/status';
import { CommentApprovalTableComponent } from '../CustomerCommentApprovalPage/components/CommentApprovalTableComponent';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { downloadExcel } from '../../utils/excelFileHelper';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import TimeHelper from '../../utils/time';
import { CCAPP, ccappCls } from './customerCommentApproval.classes';

export const CustomerCommentApprovalPage: FC<any> = () => {
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [statusName, setStatusName] = React.useState(1);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [reviewSummeries, setReviewSummaries] = React.useState<any>([]);
    const [recordCount, setRecordCount] = useState<any>(0);
    const [operators, setOperators] = React.useState([]);
    const [operatorId, setOperatorId] = React.useState();
    const [specialColor, setSpecialColor] = React.useState<string>('');
    const [rejectList, setRejectList] = React.useState<any>([]);
    const [loading, setLoading] = useState(false);

    const handleChangeOperator = (event: any) => {
        setOperatorId(event.target.value);
    };
    let envType: string = import.meta.env.VITE_ENVIRONMENT!;
    const operatorRoleID = Object.entries(enumCommentRoleID).find(([key]) => key === envType)?.[1];
    let array_: any = [
        {
            applicationUserId: 1,
            combinedId: '',
            createDate: '',
            domainName: '',
            email: '',
            hrref: '?',
            isActive: true,
            updateDate: '',
            userRef: -1,
            username: 'Tümü',
        },
    ];
    const _handlChangeDate = (event: any) => {
        setStartDate(event[0]);
        setEndDate(event[1]);
    };
    function addOneDay(dateString: any) {
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    const handleChangeRows = (event: any) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };
    function transformAndTrim(input: any) {
        const transformedValue = input.replace(/\s+/g, '').replace('-', '_');

        return transformedValue;
    }
    const GetRejectReviewsList = async () => {
        try {
            let rejectReviews: any = await CommentQuery.RejectProductReviews();
            setRejectList(rejectReviews);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    useEffect(() => {
        GetRejectReviewsList();
    }, []);
    const _handleChangeStatus = (event: any) => {
        setStatusName(event.target.value);
    };
    const downloadExcelHandler = (parseData: any) => {
        if (parseData.length > 0) {
            downloadExcel({
                excelDownloadData: parseData,
                excelDownloadFolderName: 'ReviewSummeries',
            });
        }
    };
    const findReasonRejectionById = (idToFind: string): string | null =>
        (rejectList.find((item: any) => item.id === idToFind) || {}).reasonRejection || null;

    const GetReviewSummaries = (flag?: any) => {
        setLoading(true);
        let params: any = {};

        if (startDate !== null) {
            params.startDate = startDate;
        }
        if (specialColor !== null || specialColor !== '') {
            params.specialCode = transformAndTrim(specialColor);
        }
        if (operatorId !== null || operatorId !== 0 || operatorId !== -1) {
            params.operatorId = operatorId;
        }
        if (endDate !== null) {
            params.endDate = addOneDay(endDate);
        }
        if (statusName !== 0) {
            params.status = statusName;
        }
        if (flag === true) {
            params.pageSize = recordCount[0];
            params.pageIndex = 0;
        } else {
            params.pageSize = rowsPerPage;
            params.pageIndex = page;
        }
        CommentCommand.GetReviewsSummaries(params)
            .then((res: any) => {
                if (res && res.length > 0) {
                    if (flag === true) {
                        let parseData = res.map((item: any) => {
                            return {
                                Id: item.optionId,
                                'Özel Kod': item.specialCode,
                                'Renk Kod': item.colorCode,
                                Marka: item.brand.name,
                                Özet: item.summary,
                                Statü:
                                    item.isApproved === 2
                                        ? 'Onaylandı'
                                        : item.isApproved === 4
                                          ? 'Reddedildi'
                                          : 'Onay Bekliyor',
                                'İptal Nedeni': findReasonRejectionById(item.cancellationReason) || '-',
                                'Operator Adı': item.operatorName || item.operatorId,
                                'Güncellenme Tarihi': TimeHelper.formatDateHour(item.approvalDate),
                            };
                        });
                        if (parseData) {
                            downloadExcelHandler(parseData);
                        }
                    } else {
                        setReviewSummaries(res);
                        setRecordCount(res[0].totalCount);
                    }
                } else {
                    setReviewSummaries([]);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const getOperatorListByRoleId = async () => {
        try {
            let operator: any = await OperatorQuery.GetOperatorListByRoleId(operatorRoleID);
            let arr: any = [...array_, ...operator.model.data];
            setOperators(arr);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    useEffect(() => {
        GetReviewSummaries(false);
    }, [page, rowsPerPage]);
    useEffect(() => {
        getOperatorListByRoleId();
    }, []);

    return (
        <SCUIContent className={`${CCAPP.page} `}>
            <Box
                className={CCAPP.filterBar}
                sx={{
                    mb: 3,
                    p: { xs: 2, md: 2.5 },
                    borderRadius: '24px',
                    border: '1px solid rgba(148, 163, 184, 0.18)',
                    background: 'linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(239,246,255,0.95) 100%)',
                    boxShadow: '0 8px 32px rgba(15, 23, 42, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                }}
            >
                {/* Special Code */}
                <Box
                    className={CCAPP.filterSpecialCode}
                    sx={{ flex: 1, minWidth: { xs: '100%', md: 0 }, display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <QrCodeRoundedIcon sx={{ color: '#7c3aed', fontSize: 22, flexShrink: 0 }} />
                    <TextField
                        id="outlined-helperText"
                        size="small"
                        fullWidth
                        label={t('customerInformation.speacialColorCode') as string}
                        className={ccappCls(CCAPP.input, CCAPP.inputTextfield, CCAPP.fieldSpecialCode)}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '14px' } }}
                        onChange={(event: any) => {
                            setSpecialColor(event.target.value.toUpperCase());
                        }}
                    />
                </Box>

                {/* Date Range */}
                <Box
                    className={CCAPP.filterDateRange}
                    sx={{ flex: 1, minWidth: { xs: '100%', md: 0 }, display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <CalendarMonthRoundedIcon sx={{ color: '#0f766e', fontSize: 22, flexShrink: 0 }} />
                    <Box sx={{ flex: 1 }} className={CCAPP.fieldDateRange}>
                        <SCUIDateRanger size="small" setDateRange={_handlChangeDate} dateFormat="YYYY-MM-DD" />
                    </Box>
                </Box>

                {/* Status */}
                <Box
                    className={CCAPP.filterStatus}
                    sx={{ flex: 1, minWidth: { xs: '100%', md: 0 }, display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <TaskAltRoundedIcon sx={{ color: '#16a34a', fontSize: 22, flexShrink: 0 }} />
                    <FormControl fullWidth size="small" className={CCAPP.fieldStatus}>
                        <InputLabel id="statusSelectLabel">{t('customerInformation.status') as string}</InputLabel>
                        <Select
                            id="statusSelect"
                            value={statusName}
                            label="Durum"
                            onChange={_handleChangeStatus}
                            sx={{ borderRadius: '14px' }}
                            className={ccappCls(CCAPP.input, CCAPP.inputSelect, CCAPP.fieldStatus)}
                        >
                            <MenuItem value={0}>{t('general.all') as string}</MenuItem>
                            <MenuItem value={1}>{t('general.waitingForApproval') as string}</MenuItem>
                            <MenuItem value={2}>{t('general.approved') as string}</MenuItem>
                            <MenuItem value={4}>{t('general.declined') as string}</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* Operator */}
                {operators && (
                    <Box
                        className={CCAPP.filterOperator}
                        sx={{ flex: 1, minWidth: { xs: '100%', md: 0 }, display: 'flex', alignItems: 'center', gap: 1 }}
                    >
                        <PersonSearchRoundedIcon sx={{ color: '#ea580c', fontSize: 22, flexShrink: 0 }} />
                        <FormControl fullWidth size="small" className={CCAPP.fieldOperator}>
                            <InputLabel id="opertorselectlabel">{t('general.operator') as string}</InputLabel>
                            <Select
                                labelId="opertorselectlabel"
                                id="opertorselect"
                                label={t('general.operator') as string}
                                value={operatorId}
                                onChange={handleChangeOperator}
                                sx={{ borderRadius: '14px' }}
                                className={ccappCls(CCAPP.input, CCAPP.inputSelect, CCAPP.fieldOperator)}
                            >
                                {operators.map((operator: any) => (
                                    <MenuItem key={operator.username} value={operator.userRef}>
                                        {operator.username}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                )}

                {/* Action Buttons */}
                <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 1.5 }} className={CCAPP.filterActions}>
                    <Tooltip title="Ara">
                        <IconButton
                            aria-label="search"
                            className={ccappCls(CCAPP.input, CCAPP.inputIconButton, CCAPP.btnSearch)}
                            onClick={() => {
                                GetReviewSummaries(false);
                                setPage(0);
                                setRowsPerPage(10);
                            }}
                            sx={{
                                border: '1px solid rgba(37, 99, 235, 0.25)',
                                backgroundColor: 'rgba(37, 99, 235, 0.06)',
                                color: '#2563eb',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(37, 99, 235, 0.14)',
                                    transform: 'scale(1.08)',
                                    boxShadow: '0 4px 14px rgba(37, 99, 235, 0.25)',
                                },
                            }}
                        >
                            <SearchRoundedIcon />
                        </IconButton>
                    </Tooltip>
                    {reviewSummeries.length > 0 && (
                        <Tooltip title="Excel İndir">
                            <IconButton
                                aria-label="export"
                                className={ccappCls(CCAPP.input, CCAPP.inputIconButton, CCAPP.btnExportExcel)}
                                onClick={() => {
                                    GetReviewSummaries(true);
                                }}
                                sx={{
                                    border: '1px solid rgba(22, 163, 74, 0.25)',
                                    backgroundColor: 'rgba(22, 163, 74, 0.06)',
                                    color: '#16a34a',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(22, 163, 74, 0.14)',
                                        transform: 'scale(1.08)',
                                        boxShadow: '0 4px 14px rgba(22, 163, 74, 0.25)',
                                    },
                                }}
                            >
                                <FileDownloadRoundedIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </Box>
            <CommentApprovalTableComponent
                datas={reviewSummeries}
                recordCount={recordCount}
                page={page}
                rowsPerPage={rowsPerPage}
                setPage={setPage}
                GetReviewSummaries={GetReviewSummaries}
                handleChangeRows={handleChangeRows}
                rejectList={rejectList}
                loading={loading}
            />
        </SCUIContent>
    );
};
